<template>
  <header class="header">
    <MainNavigation />
  </header>
</template>
<script>
import MainNavigation from "./MainNavigation";

export default {
  name: "Header",
  components: { MainNavigation },
};
</script>